import { render, staticRenderFns } from "./HomePopularAttraction.vue?vue&type=template&id=f848273c"
import script from "./HomePopularAttraction.vue?vue&type=script&lang=js"
export * from "./HomePopularAttraction.vue?vue&type=script&lang=js"
import "./HomePopularAttraction.vue?vue&type=style&index=0&id=f848273c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports